module.exports = __webpack_public_path__ + "img/mylearners.764932e1.png";